import { Box } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import { useCSVReader } from 'react-papaparse';

type Props = {
  onChange: (csvResult: CSVUploadResult) => any;
  loading?: boolean;
  toJson?: boolean;
};

export type CSVUploadResult = {
  data: any[][];
  errors: any[];
  meta: any[];
  json?: Record<string, string>[];
};

export default function CSVUploader({ onChange, loading = false, toJson }: Props) {
  const { CSVReader } = useCSVReader();

  const csvConfig = {
    skipEmptyLines: true,
  };

  const handleChange = (csvResult: CSVUploadResult) => {
    if (!toJson) return onChange(csvResult);

    const jsonData = csvArrayToJson(csvResult.data);
    onChange({ ...csvResult, json: jsonData });
  };

  const csvArrayToJson = (data: string[][]) => {
    const [headers, ...rows] = data;

    const jsonData = rows.map((row) => {
      const json: Record<string, string> = {};

      for (const i in headers) {
        const header = headers[i];
        json[header] = row[i];
      }

      return json;
    });

    return jsonData;
  };

  return (
    <CSVReader onUploadAccepted={handleChange} config={csvConfig}>
      {({ getRootProps, acceptedFile }: any) => (
        <Box display="flex" flexDirection="row">
          <Box
            variant={loading ? 'outlined' : 'contained'}
            bgcolor={loading ? 'transparent' : 'rgb(25, 118, 210)'}
            color={loading ? 'text.primary' : 'white'}
            sx={{ cursor: 'pointer' }}
            display="flex"
            alignItems="center"
            p={1}
            {...getRootProps()}
          >
            <UploadIcon />
            Upload
          </Box>
          <Box border="1px solid #eee" p={1} px={2} flex={1}>
            {acceptedFile?.name ?? 'No uploaded file yet'}
          </Box>
        </Box>
      )}
    </CSVReader>
  );
}
